module.exports = __webpack_public_path__ + "img/avatar1.ab3d33a9.png";